import React, { Fragment } from "react";
import {
  Modal,
  ModalFooter,
  ModalBody,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Label,
  Input,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  ModalHeader,
} from "reactstrap";
import PropTypes from "prop-types";
import LoadingSpinner from "./LoadingSpinner";
import CharityDetailModal from "../Charities/CharityDetailModal";
import {
  GetCharityList,
  GetCharityCategories,
  StatesList,
} from "../../Code/Data";

const BLANK_CATEGORY = {
  CategoryId: "",
  CategoryName: "-- Filter By Category --",
  Title: "",
  Description: "",
};

const BLANK_LOCALE = {
  value: "",
  label: "--",
};

const CHARITY_LOCALES = [
  BLANK_LOCALE,
  {
    value: "INTERNATIONAL",
    label: "International",
  },
  {
    value: "NATIONAL",
    label: "National",
  },
  ...StatesList,
];

export default class CharitySelectionModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ourCharityList: null,
      localCharityList: null,
      charityCategories: null,
      errMsg: null,
      activeTab: "ourCharities",
      searchQuery: "",
      selectedCategory: BLANK_CATEGORY,
      selectedCharity: props.selectedCharity,
      selectedLocale: BLANK_LOCALE,
      showCharityDetailModal: false,
    };

    this.cancelModal = this.cancelModal.bind(this);
    this.makeSelection = this.makeSelection.bind(this);
    this.setActiveTab = this.setActiveTab.bind(this);
  }

  async componentWillMount() {
    try {
      let charityList = await GetCharityList();
      let ourCharityList = charityList.filter(charity => !charity.IsLocal);
      let localCharityList = charityList.filter(
        charity => charity.IsLocal && charity.Locations
      );
      let charityCategories = [
        BLANK_CATEGORY,
        ...(await GetCharityCategories()),
      ];
      console.log("READY", {
        ourCharityList,
        localCharityList,
        charityCategories,
      });
      this.setState({ ourCharityList, localCharityList, charityCategories });
    } catch (e) {
      console.error("ERROR FETCHING CHARITY LISTS:", e);
      this.setState({ errMsg: e });
    }
  }

  cancelModal() {
    this.setState({
      activeTab: "ourCharities",
      selectedCharity: this.props.selectedCharity,
      selectedCategory: BLANK_CATEGORY,
      searchQuery: "",
      selectedLocale: BLANK_LOCALE,
      showCharityDetailModal: false,
    });
    this.props.onClose(this.props.selectedCharity);
  }

  makeSelection() {
    let { selectedCharity } = this.state;
    this.props.onClose(selectedCharity);
  }

  setActiveTab(activeTab) {
    this.setState({ activeTab });
  }

  render() {
    const { isOpen, onClose } = this.props;
    const {
      activeTab,
      ourCharityList,
      localCharityList,
      charityCategories,
      searchQuery,
      selectedCategory,
      selectedCharity,
      selectedLocale,
      showCharityDetailModal,
      errMsg,
    } = this.state;
    const hasError = !!errMsg;
    const isLoading =
      !ourCharityList || !localCharityList || !charityCategories;
    let modalContents = [];

    if (hasError) {
      modalContents = (
        <ModalBody>
          <p>{errMsg}</p>
        </ModalBody>
      );
    } else if (isLoading) {
      modalContents = (
        <ModalBody>
          <LoadingSpinner />
        </ModalBody>
      );
    } else {
      let hasSelectedCategory = !!selectedCategory.CategoryId.length;
      let ourCharityListFiltered =
        activeTab === "ourCharities" &&
        (hasSelectedCategory || searchQuery.length)
          ? ourCharityList.filter(
              charity =>
                (!hasSelectedCategory ||
                  charity.CategoryId === selectedCategory.CategoryId) &&
                charity.CharityName.toLowerCase().indexOf(
                  searchQuery.toLowerCase()
                ) !== -1
            )
          : ourCharityList;
      let localCharityListFiltered =
        activeTab === "localCharities" && selectedLocale.value !== ""
          ? localCharityList.filter(charity =>
              charity.Locations.includes(selectedLocale.value)
            )
          : [];
      modalContents = (
        <Fragment>
          <ModalHeader>
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab === "ourCharities" ? "active" : ""}
                  onClick={() => this.setActiveTab("ourCharities")}>
                  Our Charities
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "localCharities" ? "active" : ""}
                  onClick={() => this.setActiveTab("localCharities")}>
                  Search for a Local Charity
                </NavLink>
              </NavItem>
            </Nav>
          </ModalHeader>
          <ModalBody>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="ourCharities">
                <Row>
                  <Col sm="12">
                    <Input
                      type="search"
                      value={searchQuery}
                      onChange={e =>
                        this.setState({ searchQuery: e.target.value })
                      }
                      placeholder="Search for a charity"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Input
                      type="select"
                      value={selectedCategory.CategoryId}
                      onChange={e => {
                        let value = e.target.value;
                        let selectedCategory = charityCategories.filter(
                          category => category.CategoryId === value
                        )[0];
                        console.log(
                          "SELECTED CATEGORY",
                          JSON.stringify(value, null, 4),
                          JSON.stringify(selectedCategory, null, 4)
                        );
                        this.setState({ selectedCategory });
                      }}>
                      {charityCategories.map(category => (
                        <option
                          key={`category-${category.CategoryId}`}
                          value={category.CategoryId}>
                          {category.CategoryName}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Input
                      type="select"
                      value={selectedCharity ? selectedCharity.CharityId : ""}
                      onChange={e => {
                        let value = +e.target.value;
                        let selectedCharity = ourCharityListFiltered.filter(
                          charity => charity.CharityId === value
                        )[0];
                        console.log(
                          "SELECTED CHARITY",
                          value,
                          JSON.stringify(selectedCharity, null, 4)
                        );
                        this.setState({ selectedCharity });
                      }}
                      size="10">
                      {ourCharityListFiltered.map(charity => (
                        <option
                          key={`charity-${charity.CharityId}`}
                          onDoubleClick={e => onClose(charity)}
                          value={charity.CharityId}>
                          {charity.CharityName}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>
                <Row className="charity-select-actions">
                  <Button
                    color="primary"
                    onClick={() =>
                      this.setState({ showCharityDetailModal: true })
                    }>
                    View
                  </Button>
                  <Button color="primary" onClick={this.makeSelection}>
                    Select
                  </Button>
                </Row>
              </TabPane>
              <TabPane tabId="localCharities">
                <Row>
                  <Col>
                    <Label>Choose a Location</Label>
                    <Input
                      type="select"
                      value={selectedLocale.value}
                      onChange={e => {
                        let value = e.target.value;
                        let selectedLocale = CHARITY_LOCALES.filter(
                          locale => locale.value === value
                        )[0];
                        console.log(
                          "SELECTED LOCALE",
                          JSON.stringify(value, null, 4),
                          JSON.stringify(selectedLocale, null, 4)
                        );
                        this.setState({ selectedLocale });
                      }}>
                      {CHARITY_LOCALES.map(locale => (
                        <option
                          key={`charity-locale-${locale.value}`}
                          value={locale.value}>
                          {locale.label}
                        </option>
                      ))}
                    </Input>
                  </Col>
                </Row>
                {selectedLocale.value !== "" && (
                  <Fragment>
                    <Row>
                      <Col>
                        <p>{`There ${
                          localCharityListFiltered.length === 1 ? "is" : "are"
                        } ${localCharityListFiltered.length} ${
                          localCharityListFiltered.length === 1
                            ? "charity"
                            : "charities"
                        } registered in ${selectedLocale.label}:`}</p>
                        <ListGroup className="local-charity-list">
                          {localCharityListFiltered.map(charity => (
                            <ListGroupItem
                              active={
                                selectedCharity &&
                                charity.CharityId === selectedCharity.CharityId
                              }
                              key={charity.CharityId}
                              onClick={e =>
                                this.setState({ selectedCharity: charity })
                              }>
                              <ListGroupItemHeading>
                                {charity.CharityName}
                              </ListGroupItemHeading>
                              <ListGroupItemText>
                                {charity.ShortDescription}
                              </ListGroupItemText>
                            </ListGroupItem>
                          ))}
                        </ListGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={3}>
                        <Button color="primary" onClick={this.makeSelection}>
                          Select
                        </Button>
                      </Col>
                    </Row>
                  </Fragment>
                )}
              </TabPane>
            </TabContent>
          </ModalBody>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <Modal
          className="charity-select-modal"
          isOpen={isOpen}
          size="lg"
          toggle={this.cancelModal}>
          {modalContents}
          <ModalFooter>
            <Button color="primary" onClick={this.cancelModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
        <CharityDetailModal
          isOpen={showCharityDetailModal}
          charity={selectedCharity}
          selected={
            (selectedCharity && selectedCharity.CharityId) ===
            (this.props.selectedCharity && this.props.selectedCharity.CharityId)
          }
          onClose={() => this.setState({ showCharityDetailModal: false })}
          makeSelection={this.makeSelection}
        />
      </Fragment>
    );
  }
}
CharitySelectionModal.propTypes = {
  isOpen: PropTypes.bool,
};
CharitySelectionModal.defaultProps = {
  isOpen: false,
  onClose: () => {},
};
